const ButtonStyle = {
  Default: '_default',
  DefaultBorder: 'defaultBorder',
  IconBase: 'iconBase',
  Icon: 'icon',
  NoBackground: 'noBackground',
  Login: 'login',
  Submit: 'submit',
  Cancel: 'cancel',
  Popup: 'popup',
  PopupContext: 'popupContext',
  Header: 'header',
  HeaderLogo: 'headerLogo',
};

export default ButtonStyle;
